<nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">

      <a class="navbar-item" (click)="toggleMenu()">
        <fa-icon class="menu-icon" [icon]="faBars"></fa-icon>
      </a>
      <a class="navbar-item" [routerLink]="['/home']" >
        <!-- <img src="/public/fuchs-logo.jpeg" alt="fuchs-logo" width="125" height="75"> -->
        <img ngSrc="/assets/logo2-fuchs.png" alt="fuchs-logo" width="150" height="75" priority="true" />
      </a>  
      
      <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
  
    <div id="navbarBasicExample" class="navbar-menu">
      <div class="navbar-end">
        <div class="navbar-item user-name" (click)="logout()">
          <span>{{ authService.getUser()?.name }}</span>
          <fa-icon class="logout-icon" [icon]="faArrowRightFromBracket"></fa-icon>
        </div>
      </div>
    </div>
  </nav>
  